<template>
  <v-row :class="$vuetify.breakpoint.mdAndDown ? 'flex-column-reverse' : 'flex-row'">
    <v-col class="py-0 col-lg-2">
        <sc-placeholder name="jsstopmenubacklink" :rendering="rendering" />
    </v-col>
    <v-col class="py-0 col-lg-10 col-sm-12 hidden-xs-only">
        <sc-placeholder name="jsstopmenunavigation" :rendering="rendering" />
    </v-col>
  </v-row>
</template>
<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'TopMenuLayout',
  data() {
    return {
    };
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
    data: {
      type: Object,
    },
    params: {
      type: Object,
    },
  },
  components: {
    ScPlaceholder: Placeholder,
  },
};
</script>
<style lang="scss" scoped>
</style>
